import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Clientes from "./components/Clientes";
import Productos from "./components/Productos";
import Ventas from "./components/Ventas";
import Emisiones from "./components/Emisiones";
import { isTokenValid, logout } from "./utils/auth";
import Anulaciones from "./components/Anulaciones";
import Historial from "./components/Historial";
import MainLayout from "./layouts/MainLayouts";
import Noticias from "./components/Noticias";

function App() {
  console.log("🌍 API Base URL:", process.env.REACT_APP_API_URL);
  const [autenticado, setAutenticado] = useState(!!localStorage.getItem("token"));
  // 🕒 Verificar expiración cada cierto tiempo
  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem("token");
      if (!isTokenValid(token)) {
        logout();
      }
    }, 60000); // verifica cada 60 segundos
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    logout();
    setAutenticado(false);
  };
  
  return (
    <Router>
      {!autenticado ? (
        <Routes>
          <Route path="*" element={<Login onLogin={() => setAutenticado(true)} />} />
        </Routes>

      ) : (
        <MainLayout>
          <Routes>
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/productos" element={<Productos />} />
            <Route path="/ventas" element={<Ventas />} />
            <Route path="/emisiones" element={<Emisiones />} />
            <Route path="/anulaciones" element={<Anulaciones />} />
            <Route path="/historial" element={<Historial />} />
            <Route path="*" element={<Navigate to="/noticias" />} />
          </Routes>
        </MainLayout>
      )}
    </Router>
  );
}

export default App;
